import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const BarChart = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.5 46V27.625H46V46H35.5ZM19.75 46V4H30.25V46H19.75ZM4 46V17.125H14.5V46H4Z"
        fill={color}
      />
    </svg>
  )
}
